export function getApiBaseUrl(): string {
  return process.env.REACT_APP_API_URL?.trim()
    || (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api');
}

/** Resolve authenticated file paths against the configured API, including split-origin setups. */
export function resolveApiFileUrl(url: string, apiBaseUrl: string): string {
  return url.startsWith('/api/')
    ? `${apiBaseUrl.replace(/\/$/, '')}${url.slice(4)}`
    : url;
}

/** Send session cookies to FORXA's page/API origins, never to signed storage links. */
export function shouldSendFileCredentials(
  url: string | undefined,
  pageUrl = window.location.href,
  apiBaseUrl = getApiBaseUrl(),
): boolean {
  if (!url) return false;
  try {
    const page = new URL(pageUrl);
    const file = new URL(url, page);
    return file.origin === page.origin || file.origin === new URL(apiBaseUrl, page).origin;
  } catch { return false; }
}
